import { render, staticRenderFns } from "./CustomerNoteList.vue?vue&type=template&id=5c7cf0e9&scoped=true&lang=pug&"
import script from "./CustomerNoteList.vue?vue&type=script&lang=js&"
export * from "./CustomerNoteList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNoteList.vue?vue&type=style&index=0&id=5c7cf0e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7cf0e9",
  null
  
)

export default component.exports